import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, ShieldCheckIcon, ZapIcon, LockIcon, CreditCardIcon } from 'lucide-react';
function useCountdown(initialMinutes: number) {
  const [s, setS] = useState(initialMinutes * 60);
  useEffect(() => {
    const t = setInterval(() => setS(v => v > 0 ? v - 1 : 0), 1000);
    return () => clearInterval(t);
  }, []);
  return {
    h: String(Math.floor(s / 3600)).padStart(2, '0'),
    m: String(Math.floor(s % 3600 / 60)).padStart(2, '0'),
    sec: String(s % 60).padStart(2, '0')
  };
}
const includes = ['Ebook completo (6 módulos)', 'Bonus 1: 50 frases para responder sin pelear', 'Bonus 2: Detectar manipuladores rápidamente', 'Bonus 3: Manejar jefes difíciles', 'Bonus 4: Dejar de absorber problemas ajenos', 'Bonus Premium: Personalidades difíciles explicadas', 'Acceso de por vida', 'Acceso desde cualquier dispositivo'];
export function OfferSection() {
  const {
    h,
    m,
    sec
  } = useCountdown(14);
  return <section id="oferta" className="w-full py-20 md:py-28 px-4" data-id="element-242" data-mp="12otg7ix4xfjj">
      <div className="max-w-3xl mx-auto" data-id="element-243" data-mp="xvqtnuqrz6cu">
        {/* Countdown bar */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-244" data-mp="sxfi9fku0nsi">
          <div className="inline-flex items-center gap-2 text-rose font-bold tracking-widest text-xs mb-3" data-id="element-245" data-mp="1gn9vvzcz6gdt">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-246" data-mp="1cjv7akaz0ror">
            {[{
            v: h,
            l: 'HS'
          }, {
            v: m,
            l: 'MIN'
          }, {
            v: sec,
            l: 'SEG'
          }].map((t, i) => <Fragment key={i} data-id="element-247" data-mp="3ttpxg821xjc6" data-mpi={i}>
                <div className="bg-ink text-white rounded-2xl px-4 py-3 min-w-[70px] md:min-w-[80px]" data-id="element-248" data-mp="3tusp4i777pt5">
                  <div className="font-serif text-3xl md:text-4xl font-bold leading-none" data-id="element-249" data-mp="2mwylauqdwat">
                    {t.v}
                  </div>
                  <div className="text-[10px] tracking-widest text-white/60 mt-1" data-id="element-250" data-mp="3oudevzi7qyfe">
                    {t.l}
                  </div>
                </div>
                {i < 2 && <span className="text-rose text-2xl font-bold" data-id="element-251" data-mp="3fu87vqgxm21r">:</span>}
              </Fragment>)}
          </div>
          <p className="text-sm text-muted mt-3" data-id="element-252" data-mp="316n55xnyy4ud">⚠️ Después sube. No vuelve.</p>
        </motion.div>

        {/* Stock indicator */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-line rounded-2xl p-4 mb-8" data-id="element-253" data-mp="362c9sfeuibxj">
          <div className="flex items-center justify-between mb-2 text-sm font-semibold text-ink" data-id="element-254" data-mp="2digsal7p242z">
            <span className="flex items-center gap-2" data-id="element-255" data-mp="28kf0nbw7cwfw">
              <span className="w-2 h-2 rounded-full bg-rose animate-pulse" data-id="element-256" data-mp="2mj4xcqf40u3q" />{' '}
              Cupos al precio actual
            </span>
            <span className="text-rose" data-id="element-257" data-mp="2ifgp05inluhf">72%</span>
          </div>
          <div className="h-2 bg-bg-warm rounded-full overflow-hidden" data-id="element-258" data-mp="2wg9j4p51mnk0">
            <div className="h-full bg-rose rounded-full" style={{
            width: '72%'
          }} data-id="element-259" data-mp="2rhpyqt63ljtr" />
          </div>
          <p className="text-xs text-muted mt-2" data-id="element-260" data-mp="365t4q2k54vik">
            72% de los cupos ya fueron tomados
          </p>
        </motion.div>

        {/* Offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10" data-id="element-261" data-mp="3f6iyz1tr6du6">
          <div className="text-center mb-6" data-id="element-262" data-mp="1i9d8eh2ccswu">
            <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-3 py-1 rounded-full mb-4" data-id="element-263" data-mp="1ma6y9fzcghsd">
              <span className="text-[11px] font-bold tracking-widest" data-id="element-264" data-mp="pkpha4uwv9bd">
                ⭐ OFERTA ESPECIAL
              </span>
            </div>
            <h2 className="font-serif font-bold text-3xl md:text-4xl text-ink uppercase tracking-tight leading-tight" data-id="element-265" data-mp="ujsljn32hbia">
              Cómo Trabajar con{' '}
              <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-266" data-mp="13kgtc01vafmq">
                Gente Complicada
              </span>
            </h2>
            <p className="font-serif-italic text-rose text-lg mt-2" data-id="element-267" data-mp="2a23xm7llxhcl">
              6 Módulos + 5 Bonus
            </p>
          </div>

          {/* Mockup */}
          <div className="flex justify-center mb-6" data-id="element-268" data-mp="2p1zo7k1sse8l">
            <img src="https://cdn.magicpatterns.com/uploads/7vb5BSSJbz8Kc6emHvnBm7/como_trabajar_con_gente_complicada.png" alt="Ebook Cómo Trabajar con Gente Complicada" className="h-52 md:h-60 w-auto object-contain drop-shadow-xl" data-id="element-269" data-mp="2p4vohf14bf07" />
          </div>

          {/* Price */}
          <div className="text-center mb-7" data-id="element-270" data-mp="26d2upie85prf">
            <div className="text-muted line-through mb-1 text-[14px]" data-id="element-271" data-mp="26duqat7tnnhp">
              $39.980+$46.000
            </div>
            <div className="flex items-baseline justify-center gap-2 flex-wrap" data-id="element-272" data-mp="21ft43zf3n820">
              <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-273" data-mp="1wen8ntu216os">
                $19.990
              </span>
              <span className="text-lg text-ink-soft" data-id="element-274" data-mp="3qsekmzzuw2ne">ARS</span>
            </div>
            <div className="text-sm text-muted mt-2" data-id="element-275" data-mp="3qq232ny0fuav">
              Pago único · Acceso de por vida
            </div>
          </div>

          {/* Includes */}
          <div className="bg-bg-warm border border-line rounded-2xl p-5 md:p-6 mb-7" data-id="element-276" data-mp="1k3chy09iwr2u">
            <div className="text-xs font-bold text-rose tracking-widest mb-4 text-center" data-id="element-277" data-mp="1ovw6ttdnv8my">
              INCLUYE TODO ESTO
            </div>
            <ul className="space-y-2.5" data-id="element-278" data-mp="1b1d0j6uljkzd">
              {includes.map((it, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-279" data-mp="1f5ktjg837n3e" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-280" data-mp="22votndm2h4pn">
                    <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-281" data-mp="27t6wcm9hqnp7" />
                  </span>
                  <span className="text-ink" data-id="element-282" data-mp="1ttnyqneb2ur5">{it}</span>
                </li>)}
            </ul>
          </div>

          <a href="https://checkout.aula-mater.online/cart/66742180839469:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full text-center shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-283" data-mp="1yuv7aoo9vxyv">
            <ArrowRightIcon className="w-5 h-5" data-id="element-284" data-mp="ju4sh14sw5l9" />
            QUIERO MI ACCESO AHORA
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-285" data-mp="3s9elljqpq0gw">
            <span className="flex items-center gap-1.5" data-id="element-286" data-mp="5w6g21a1ij8e">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-287" data-mp="5xrbdt46i67b" /> Pago seguro
            </span>
            <span className="text-line" data-id="element-288" data-mp="14oepc43ugmw">|</span>
            <span className="flex items-center gap-1.5" data-id="element-289" data-mp="39l9mipl033of">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-290" data-mp="39jov38tzg0us" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-291" data-mp="34lncsq4ds5kd">|</span>
            <span className="flex items-center gap-1.5" data-id="element-292" data-mp="2j33njqwdixeh">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-293" data-mp="2j4eufzl48l9t" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-294" data-mp="2o415c2dh1pfg">|</span>
            <span className="flex items-center gap-1.5" data-id="element-295" data-mp="2t0rtze3cdtch">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-296" data-mp="2t3e2ph1yyewa" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}